module.exports = __webpack_public_path__ + "static/media/poweredBy.2f0fe430.png";